import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { animated, useTransition } from 'react-spring';
import { useShallow } from 'zustand/react/shallow';

import useStore from 'state/state';

// import Menu from 'components/Menu/Menu';
import Home from 'components/Home/Home';
import NewUserPage from 'components/NewUserPage/NewUserPage';
import NotFound from 'components/NotFound/NotFound';
import Logo from 'assets/images/logo.svg';

import styles from './app.module.scss';

// const menuDataState = (state) => state.setIsMenuOpen;
const isErrorState = (state) => [state.isError, state.setIsError];
const isInfoMessageState = (state) => [
  state.isInfoMessage,
  state.setIsInfoMessage,
];
const tokenDataState = (state) => state.setTokenData;

const App = () => {
  const location = useLocation();
  // const setIsMenuOpen = useStore(menuDataState);
  const [isError, setIsError] = useStore(useShallow(isErrorState));
  const [isInfoMessage, setIsInfoMessage] = useStore(
    useShallow(isInfoMessageState)
  );
  const setTokenData = useStore(tokenDataState);

  const routerTransitions = useTransition(location, {
    keys: (routeLocation) => routeLocation.pathname,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setTokenData(savedToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsError(null);
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  useEffect(() => {
    if (isInfoMessage) {
      setTimeout(() => {
        setIsInfoMessage(null);
      }, 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInfoMessage]);

  return (
    <div className={styles.wrapper}>
      <Logo className={styles.topLogo} />
      {isError && <div className={styles.errorModal}>{isError}</div>}
      {isInfoMessage && (
        <div className={`${styles.errorModal} ${styles.infoModal}`}>
          {isInfoMessage}
        </div>
      )}
      {/* {tokenData && (
        <button
          className={styles.menuButton}
          onClick={setIsMenuOpen}
          type="button"
        >
          <div className={styles.menuButtonLine}>
            <span className="screen-reader-text">Open menu</span>
          </div>
        </button>
      )} */}

      {/* {tokenData && <Menu />} */}

      {routerTransitions((style, item) => (
        <animated.div className={styles.routesWrapper} style={style}>
          <Routes location={item}>
            <Route path="/" element={<Home />} />
            <Route path="/new-user" element={<NewUserPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </animated.div>
      ))}
    </div>
  );
};

export default App;
